import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d507f8f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ps-0" }
const _hoisted_2 = { class: "d-flex flex-column mb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "texto mb-1" }, " Nome ", -1))
const _hoisted_4 = { class: "d-flex flex-column mb-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "texto mb-1" }, " Tipo ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "FilterLubrificantes",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.closeModal,
    disabledClick: false,
    onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enviarEmit()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_input, {
            placeholder: "Nome",
            clearable: "",
            type: "text",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.nome,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paramsFilter.nome) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("li", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_input, {
            placeholder: "Tipo",
            clearable: "",
            type: "text",
            class: "",
            style: {"border-radius":"5px","border":"1px solid #b5b5c3"},
            modelValue: _ctx.paramsFilter.tipoProduto,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paramsFilter.tipoProduto) = $event))
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}